export function formatMoney(value) {
  return "$" + Number(value).toLocaleString("en-NZ", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export function formatThousands(raw) {
  const cleaned = String(raw).replace(/[^\d.]/g, "")
  if (cleaned === "") return ""

  const parts = cleaned.split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return parts.join(".")
}

export function stripThousands(raw) {
  return String(raw).replace(/,/g, "")
}

export function timeSavedText(years, months) {
  let y = Number(years) || 0
  let m = Number(months) || 0
  y += Math.floor(m / 12)
  m = m % 12
  const parts = []
  if (y > 0) parts.push(`${y} ${y === 1 ? "year" : "years"}`)
  if (m > 0) parts.push(`${m} ${m === 1 ? "month" : "months"}`)
  return parts.length ? parts.join(" ") : "0 months"
}
